<app-auth-layout>
  <div class="auth-card login">
    <h2>{{ 'login.title' | transloco }}</h2>

    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <div class="input-group">
        <label for="email">{{ 'login.email.label' | transloco }}</label>
        <input type="email"
          id="email"
          placeholder="{{ 'login.email.placeholder' | transloco }}"
          formControlName="email"
          />
        @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
          <small class="error">
            {{ 'login.email.error.invalid' | transloco }}
          </small>
        }
      </div>

      <div class="input-group">
        <label for="password">{{ 'login.password.label' | transloco }}</label>
        <input type="password"
          id="password"
          placeholder="{{ 'login.password.placeholder' | transloco }}"
          formControlName="password"
          />
        <a class="password-forgotten" [routerLink]="['/reset-password']">{{ 'login.password.forgot' | transloco }}</a>
        @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
          <small class="error">
            {{ 'login.password.error.invalid' | transloco }}
          </small>
        }
      </div>

      <button class="button button--large button--full-width"
        [disabled]="loginForm.invalid || loading"
        [class.button--loading]="loading"
        >
        {{ 'login.cta-label' | transloco }} <i class="fa-solid fa-arrow-right"></i>
      </button>

      @if (errorMessage) {
        <p class="error">{{ errorMessage }}</p>
      }
    </form>

    <p class="create-account-link">
      {{ 'login.no-account' | transloco }} <a [routerLink]="['/register']">{{ 'login.register-now' | transloco }}</a>
    </p>
  </div>
</app-auth-layout>
